export const getFormData = (object: Record<string, any>): FormData => 
	Object.keys(object).reduce((formData, key) => {
		formData.append(key, object[key]);
		return formData;
	}, new FormData());